import React, { FC, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import axios from 'axios'
import { successToast, errorToast } from '../../../../../../../_metronic/helpers/components/Toaster'
import { QUERIES } from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import UploadImage from '../../../../../../../_metronic/helpers/components/ImageUpload'
import { useFormik } from 'formik'
import * as Yup from 'yup'

type Props = {
    id: any
    close: () => void
}

const ApprovalModal: FC<Props> = ({ id, close }) => {
    const { query } = useQueryResponse()
    const queryClient = useQueryClient()
    const [loading, setLoading] = useState(false)

    const validationSchema = Yup.object().shape({
        remarks: Yup.string().required('Remarks is required'),
        poCopy: Yup.string().required('PO Copy is required'),
    })

    const formik = useFormik({
        initialValues: {
            remarks: '',
            poCopy: '',
        },
        validationSchema,
        onSubmit: handleApprove,
    })

    async function handleApprove() {
        try {
            setLoading(true)

            // Get auth token and user info from localStorage
            const authData = localStorage.getItem('kt-auth-react-v')
            const token = authData ? JSON.parse(authData).data.token : null
            const userId = authData ? JSON.parse(authData).data.userId : 'F2001'
            const userName = authData ? JSON.parse(authData).data.userName : 'FinanceUser'

            console.log('Using userId:', userId)
            console.log('Using userName:', userName)

            // Make API call to approve order
            const response = await axios.post(
                `https://pfc-backend-api.asmglobal.co.in/v1/api/transactions/${id.id}/finance-approve`,
                {
                    purchaseOrderUrls: [formik.values.poCopy],
                    remark: formik.values.remarks,
                },
                {
                    params: {
                        userId: userId,
                        userName: userName,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            )

            console.log('Approval Response:', response.data)
            successToast('Order approved successfully!')
            queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
            close()
        } catch (error) {
            console.error('Error approving order:', error)
            if (error instanceof Error) {
                errorToast(error.message)
            } else {
                errorToast('Error approving order')
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 2000,
            }}
            onClick={close}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    padding: '30px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    maxWidth: '500px',
                    width: '90%',
                    maxHeight: '90vh',
                    overflowY: 'auto',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <h3 style={{ marginBottom: '20px', fontWeight: 600, fontSize: "17.55px" }}>Approve Order</h3>

                <form onSubmit={formik.handleSubmit} noValidate>
                    {/* Remarks Field */}
                    <div className='fv-row mb-7'>
                        <label className='required fw-bold fs-6 mb-2' style={{ color: "black" }}>Remarks</label>
                        <textarea
                            {...formik.getFieldProps('remarks')}
                            placeholder='Enter approval remarks...'
                            className='remarks-textarea'
                            style={{
                                width: '100%',
                                padding: '10px',
                                border: formik.touched.remarks && formik.errors.remarks ? '1px solid #f8285a' : '1px solid #ddd',
                                borderRadius: '4px',
                                fontFamily: 'inherit',
                                minHeight: '100px',
                                resize: 'vertical',
                                color: "#000"
                            }}
                            disabled={loading}
                        />
                        <style>{`
                            .remarks-textarea::placeholder,
                            input::placeholder {
                                color: black !important;
                                opacity: 1;
                            }
                        `}</style>
                        {formik.touched.remarks && formik.errors.remarks && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block' style={{ color: '#f8285a' }}>
                                    {formik.errors.remarks}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* PO Copy Upload using UploadImage component */}
                    <UploadImage
                        label='Upload PO Copy'
                        name='poCopy'
                        formik={formik}
                        filetype='image/*,.pdf'
                    />
                    {formik.touched.poCopy && formik.errors.poCopy && (
                        <div className='fv-plugins-message-container'>
                            <div className='fv-help-block' style={{ color: '#f8285a' }}>
                                {formik.errors.poCopy}
                            </div>
                        </div>
                    )}

                    {/* Action Buttons */}
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <button
                            type='button'
                            onClick={close}
                            className='btn btn-light'
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type='submit'
                            className='btn btn-success'
                            disabled={loading}
                        >
                            {loading ? 'Approving...' : 'Approve'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ApprovalModal